import { useQuery } from '@tanstack/react-query';
import { authorizedBuyersLookupCacheKey } from './authorized-buyers-lookup-cache-key';
import queryFnFactory from './authorized-buyers-lookup-query';
export function useAuthorizedBuyersLookupGetQuery({ config, keyProps, queryOptions = {} }) {
    return useQuery({
        queryKey: authorizedBuyersLookupCacheKey(keyProps.membershipNumber),
        queryFn: queryFnFactory(config, keyProps),
        retry: false,
        ...queryOptions
    });
}
